<template>
  <div class="container">
    <div class="row">
      <form @submit.prevent="addAccountForm">
        <div id="step4" class="col-xs-12 text-center">
          <registration-progress-bar
            title-reg="Administration Account"
            progress="90"
          ></registration-progress-bar>
          <br />

          <div class="registrationFields">
            <h4>Primary Contact Info</h4>

            <registration-errors></registration-errors> <br />

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="first_name">First Name:</label>
                  <input
                    id="first_name"
                    v-model="first_name"
                    type="text"
                    name="first_name"
                    class="form-control"
                    value=""
                    required
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="last_name">Last Name:</label>
                  <input
                    id="last_name"
                    v-model="last_name"
                    type="text"
                    name="last_name"
                    class="form-control"
                    value=""
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="phone">Phone:</label>
                  <input
                    ref="phone"
                    v-model="phone"
                    type="text"
                    name="phone"
                    class="form-control"
                    value=""
                    required
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="company">Organization Name:</label>
                  <!--                                    If it has a company selected then it'll have a readme otherwise it wont show -->
                  <input
                    v-if="companyOrg === '' || null"
                    ref="company"
                    v-model="company"
                    type="text"
                    name="company"
                    class="form-control"
                    value=""
                    required
                  />
                  <input
                    v-else
                    ref="company"
                    v-model="company"
                    type="text"
                    name="company"
                    class="form-control"
                    value=""
                    :readonly="companyOrg"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="email">Email:</label>
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    name="email"
                    class="form-control"
                    value=""
                    required
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div v-if="currentLocale == 'en-CA'" class="form-group">
                  <label for="email">Medical Identification Number:</label>
                  <input
                    id="npi"
                    ref="npi"
                    type="text"
                    name="npi"
                    class="form-control"
                    value=""
                  />
                </div>
                <div v-else class="alert-info alert">
                  <p>The email address will be used as your new login</p>
                </div>
                <input
                  v-if="currentLocale == 'en-US'"
                  ref="npi"
                  type="hidden"
                  name="npi"
                  :value="npiNumber"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group password">
                  <label for="password">Password:</label>
                  <input
                    id="password"
                    v-model="password"
                    type="password"
                    name="password"
                    class="form-control"
                    required
                    @keyup.prevent="validatePassword"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group password-confirm">
                  <label for="password_confirmation">Confirm Password:</label>
                  <input
                    id="password_confirmation"
                    v-model="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    class="form-control"
                    required
                    @keyup.prevent="validateMatchingPassword"
                  />
                </div>
              </div>
            </div>

            <password-rules-feedback></password-rules-feedback>

            <template v-if="!varReseller || varReseller === 'ces'">
              <div class="row form-group">
                <div class="col">
                  <h4>Vendor</h4>
                  <p v-if="!mustChooseVendor">
                    If you currently work with a Nuance® - Dragon® supplier,
                    please choose <strong>yes</strong> and use the form to
                    search and select your vendor.
                  </p>
                </div>
              </div>

              <div v-if="!mustChooseVendor" class="form-group">
                <label>I have a certified vendor:</label>
                <div class="checkbox">
                  <label>
                    <input
                      v-model="hasVendor"
                      type="radio"
                      name="has_vendor"
                      :value="true"
                      @change="hasVendorChanged()"
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      v-model="hasVendor"
                      type="radio"
                      name="has_vendor"
                      :value="false"
                      @change="hasVendorChanged()"
                    />
                    No
                  </label>
                </div>
              </div>

              <div v-if="hasVendor || mustChooseVendor" class="form-group">
                <div class="clearfix">
                  <div
                    class="pull-left"
                    style="margin: 10px 10px 0 5px"
                    aria-hidden="true"
                  >
                    <i
                      class="fa fa-arrow-down"
                      aria-hidden="true"
                      style="font-size: 25px"
                    ></i>
                  </div>
                  <label for="var_referral">
                    Please use the form below to search and select your
                    certified Nuance&reg; - Dragon® vendor.<br />
                    <small class="text-normal">
                      Note: Only certified vendors are shown in results.
                      <span v-if="!mustChooseVendor">
                        If you are unable to locate your certified reseller,
                        please select "No" above.
                      </span>
                    </small>
                  </label>
                </div>
                <vendor-search></vendor-search>
              </div>
            </template>

            <div class="checkbox">
              <label>
                <input
                  id="email_newsletters"
                  ref="email_newsletters"
                  type="checkbox"
                  name="email_newsletters"
                  value="1"
                  checked
                />
                I want to be updated with current news and promotions.
              </label>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-6">
              <div class="text-left">
                <button
                  id="step5Previous"
                  type="button"
                  class="btn btn-default"
                  @click.prevent="prevStep()"
                >
                  Previous
                </button>
              </div>
            </div>

            <div class="col-xs-6">
              <div class="text-right">
                <button
                  id="step5Register"
                  type="submit"
                  class="btn btn-primary"
                  :disabled="!checkedReferrer"
                >
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <scroll></scroll>
    <loading></loading>
    <welcome></welcome>
    <error-alert></error-alert>
  </div>
</template>

<script>
import RegistrationProgressBar from "./forms/elements/RegistrationProgressBar.vue";
import RegistrationErrors from "./forms/elements/RegistrationErrors.vue";
import PasswordRulesFeedback from "./forms/elements/PasswordRulesFeedback.vue";
import VendorSearch from "./forms/VendorSearch.vue";
import Scroll from "./forms/elements/Scroll.vue";
import Loading from "./forms/elements/Loading.vue";
import Welcome from "./forms/elements/Welcome.vue";
import ErrorAlert from "./forms/elements/ErrorAlert.vue";
/**
 * The slug to use when they user selects they have no reseller
 */
const noVendorResult = "dtpss";

export default {
  components: {
    RegistrationProgressBar,
    RegistrationErrors,
    PasswordRulesFeedback,
    VendorSearch,
    Scroll,
    Loading,
    Welcome,
    ErrorAlert,
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      company: "",
      companyOrg: "",
      email: "",
      password: "",
      password_confirmation: "",
      email_newsletters: "",
      npi: "",
      phone: "",
      var_referral: "",
      var_search: "",
      hasVendor: null,
    };
  },
  computed: {
    currentFormType() {
      return this.$store.state.registration.type;
    },
    customerSegment() {
      return this.$store.state.registration.customer_segment;
    },
    currentLocale() {
      return this.$store.state.registration.locale;
    },
    organizationName() {
      return this.extractOrganizationName(
        this.$store.state.registration.npi_info
      );
    },
    organizationPhone() {
      return this.extractOrganizationPhone(
        this.$store.state.registration.npi_info
      );
    },
    npiNumber() {
      return this.extractNpiNumber(this.$store.state.registration.npi_info);
    },
    checkedVarReseller() {
      const checkedVarReferrer = this.$store.state.registration
        .checked_reseller;
      return checkedVarReferrer || this.$store.state.registration.var_reseller;
    },
    varReseller() {
      return this.$store.state.registration.var_reseller;
    },
    validParameters() {
      return this.$store.state.registration.valid_parameters;
    },
    checkedReferrer() {
      return this.$store.state.registration.checked_reseller;
    },
    registrationErrors() {
      return this.$store.state.registration.registration_errors;
    },
    loading() {
      return this.$store.state.registration.loading;
    },
    localeId() {
      return this.$store.state.registration.locale_id;
    },
    mustChooseVendor() {
      return this.$store.state.registration.locale === "en-CA";
    },
  },
  created() {
    // During registration, default as if a user chose they had a vendor
    this.hasVendor = true;
    this.hasVendorChanged();
    this.$store.dispatch("validateValidParameters");
  },
  // This calls whatever functions on/before the state/dom is mounted, so on DOM load
  beforeMount() {
    this.checkOrg();
  },
  methods: {
    hasVendorChanged() {
      if (this.hasVendor) {
        // we're going to clear it out because they're opting to set their own
        this.$store.dispatch("setCheckedVarReseller", null);
      } else {
        this.$store.dispatch("setCheckedVarReseller", noVendorResult);
      }
    },

    addAccountForm() {
      const formFields = this.getFormFields();
      this.validateForm(formFields);
      setTimeout(() => {
        this.$store.dispatch("setLoading", true);
        this.$store.dispatch("createNewAccount", formFields);
      }, 1500);
    },
    // Check if Organization and if locale is US, if so setup data
    checkOrg() {
      const currentLocale = this.$store.state.registration.locale;
      if (currentLocale === "en-US") {
        this.company = this.organizationName;
        this.companyOrg = this.organizationName;
        this.phone = this.organizationPhone;
      } else {
        this.company = "";
        this.phone = "";
        this.companyOrg = "";
      }
    },
    validatePassword(event) {
      const password = event.target.value;
      const upper = /[A-Z]/m;
      const lower = /[a-z]/m;
      const digits = /\d/m;
      const symbols = /[\W_]/m;
      const amount = password.length > 7;

      if (upper.test(password)) {
        this.$store.dispatch("setUppercase", true);
      } else {
        this.$store.dispatch("setUppercase", false);
      }

      if (lower.test(password)) {
        this.$store.dispatch("setLowercase", true);
      } else {
        this.$store.dispatch("setLowercase", false);
      }

      if (digits.test(password)) {
        this.$store.dispatch("setDigits", true);
      } else {
        this.$store.dispatch("setDigits", false);
      }

      if (symbols.test(password)) {
        this.$store.dispatch("setSymbol", true);
      } else {
        this.$store.dispatch("setSymbol", false);
      }

      if (amount) {
        this.$store.dispatch("setAmount", true);
      } else {
        this.$store.dispatch("setAmount", false);
      }

      if (password.length === 0) {
        this.$store.dispatch("setMatching", false);
      }
    },
    validateMatchingPassword(event) {
      const { password } = this;
      const matchingPassword = event.target.value;

      if (password.length > 0 && password === matchingPassword) {
        this.$store.dispatch("setMatching", true);
      } else {
        this.$store.dispatch("setMatching", false);
      }
    },
    prevStep() {
      this.$store.dispatch("prevStep");
    },
    extractNpiNumber(npiInfo) {
      if (npiInfo) {
        const npi = npiInfo.split("|");
        return npi[0];
      }
      return null;
    },
    extractOrganizationName(npiInfo) {
      if (npiInfo) {
        const npi = npiInfo.split("|");
        return npi[1];
      }
      return null;
    },
    extractOrganizationPhone(npiInfo) {
      if (npiInfo) {
        const npi = npiInfo.split("|");
        return npi[2];
      }
      return null;
    },
    getFormFields() {
      const npi = this.$refs.npi.value ? this.$refs.npi.value : "none";
      return {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        npi,
        password: this.password,
        password_confirmation: this.password_confirmation,
        email_newsletters: this.$refs.email_newsletters.value,
        var_referral: this.checkedVarReseller,
        locale_name: this.currentLocale,
        phone: this.$refs.phone.value,
        company: this.$refs.company.value,
        locale_id: this.localeId,
        customer_segment_id: this.customerSegment.id,
      };
    },
    validateForm(fields) {
      this.$store.dispatch("registrationValidationForm", fields);
    },
  },
};
</script>
